import React,{ useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import TransactionsForm from '../../components/forms/TransactionsForm/TransactionsForm';

const TransactionView = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="transaction-view">
      <TransactionsForm userId={uid} />
    </AuthLayout>
  );
};

export default TransactionView;
